// @ts-nocheck
  document.addEventListener('DOMContentLoaded', () => {
    const sectionId = document.querySelector('product-form-component, [data-section-id]')?.dataset?.sectionId;
    const modalBackdrop = document.getElementById(`enquiry-modal-backdrop-${sectionId}`);
    const modalCard = modalBackdrop?.querySelector('.product-enquiry-modal-card');
    const openBtn = document.getElementById(`open-enquiry-btn-${sectionId}`);
    const closeBtn = document.getElementById(`close-enquiry-btn-${sectionId}`);
    const qtyPricingWrapper = document.getElementById(`quantity-and-pricing-${sectionId}`);

    if (modalBackdrop && modalBackdrop.parentElement !== document.body) {
      document.body.appendChild(modalBackdrop);
    }
    
    const openModal = () => {
      if (modalBackdrop) modalBackdrop.style.display = 'flex';
    };
    const closeModal = () => {
      if (modalBackdrop) modalBackdrop.style.display = 'none';
    };

    if (openBtn)
      openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        openModal();
      });

      
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    if (modalBackdrop) {
      modalBackdrop.addEventListener('click', (e) => {
        if (e.target === modalBackdrop) closeModal();
      });
    }

    const formContainer = modalCard?.querySelector('div[data-forms-id]');
    const formName = formContainer?.dataset?.formsId;

    if (formName && typeof window.waitForElement === 'function') {
      window.waitForElement(`div[data-forms-id='${formName}'] shopify-forms-embed`).then((form) => {
        const root = form.shadowRoot;
        if (!root) return;

        const productField = root.querySelector('[data-testid="field-custom#product"]');
        const nameField = root.querySelector('[data-testid="field-first_name"]');
        const emailField = root.querySelector('[data-testid="field-email"]');

        if (productField && productField.parentElement) {
          productField.parentElement.style.display = 'none';
        }

        setTimeout(() => {
          if (productField) {
            productField.value = '{{ product.title | escape }}';
            productField.dispatchEvent(new Event('input', { bubbles: true }));
          }
          if (nameField) {
            nameField.value = "{{ customer.first_name | default: '' }}";
            nameField.dispatchEvent(new Event('input', { bubbles: true }));
          }
          if (emailField) {
            emailField.value = "{{ customer.email | default: '' }}";
            emailField.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }, 500);
      });
    }
  });